import axios from 'axios';

import accessLocalStorage from './accessLocalStorage';
import { apiFailure, apiSuccess, runRequest } from './apiResult';

const authorizedRequest = async (method, path, dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const config = { headers: { Authorization: token } };
  const url = `${ipRequest}${path}`;
  if (method === 'get') return axios.get(url, config);
  if (method === 'put') return axios.put(url, dataRequest, config);
  if (method === 'delete') return axios.delete(url, config);
  return axios.post(url, dataRequest, config);
};

const hostRequest = async (method, path, dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const config = { headers: { Authorization: token } };
  const url = `//${ipRequest.split('/')[2]}${path}`;
  if (method === 'put') return axios.put(url, dataRequest, config);
  return axios.post(url, dataRequest, config);
};

const {
  REACT_APP_HOST,
} = process.env

export const clickToCall = async (data) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/calls/click`, data, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    console.log(error);
  }
}

export const cancelClickToCall = async (data) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios
      .post(`${ipRequest}api/calls/cancel-click`, data, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    console.log(error);
  }
}

export const trasferCall = async (data) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios
      .post(`${ipRequest}api/calls/transfer`, data, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    console.log(error);
  }
}

export const cancelTrasferCall = async (data) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios
      .post(`${ipRequest}api/calls/cancel-transfer`, data, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    console.log(error);
  }
}

export const clickToSpy = async (data) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios
      .post(`${ipRequest}api/calls/spy`, data, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    console.log(error);
  }
}

export const requestToken = async (userData, ip) => {
  try {
    const token = await axios.post(`${ip}api/login`, userData);
    return token;
  } catch (error) {
    return error;
  }
}

export const switchTenant = async (tenant) =>
  runRequest(() => authorizedRequest('post', 'api/login/switch-tenant', { tenant }), {
    fallback: 'Não foi possível acessar o cliente selecionado.'
  });

export const registerUser = async (userData) =>
  runRequest(() => authorizedRequest('post', 'api/login/register', userData), {
    fallback: 'Não foi possível criar o usuário.'
  });

export const updateUser = async (userData) =>
  runRequest(() => authorizedRequest('post', 'api/login/update', userData), {
    fallback: 'Não foi possível atualizar o usuário.'
  });

export const listUsers = async () => {
  try {
    const response = await authorizedRequest('get', 'api/login');
    return response.data;
  } catch (error) {
    return error.response?.status;
  }
}

export const deleteUser = async (data) =>
  runRequest(() => authorizedRequest('post', 'api/login/delete', data), {
    fallback: 'Não foi possível excluir o usuário.'
  });

export const userByEmail = async (data) => {
  try {
    const response = await authorizedRequest('post', 'api/login/email', data);
    return response.data;
  } catch (error) {
    return error.response?.status;
  }
}

export const fetchEndpoints = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios
      .get(`${ipRequest}api/config/endpoints/live-state`, { headers: { Authorization: token } });
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const ENDPOINT_REGISTRATIONS_TIMEOUT_MS = 8000;

export const fetchEndpointRegistrations = async (endpoint) =>
  runRequest(() => {
    const { token, ipRequest } = accessLocalStorage.getUserLocalStorage();
    return axios.get(`${ipRequest}api/config/endpoints/${encodeURIComponent(endpoint)}/registrations`, {
      headers: { Authorization: token },
      timeout: ENDPOINT_REGISTRATIONS_TIMEOUT_MS,
    });
  }, { fallback: 'Não foi possível consultar o registro agora.' });

export const fetchCallsDataBase = async (day) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/db`, day, { headers: { Authorization: token } });
    return response.data.rows;
  } catch (error) {
    return error;
  }
}

export const fetchCallsByDateDB = async (days) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/db/by-date`, days, { headers: { Authorization: token } });
    return response.data.rows;
  } catch (error) {
    return error;
  }
}

export const fetchCallsAnalistas = async (id) => {
  try {
    const request = await fetch(`${REACT_APP_HOST}/api/analistas/${id}`);
    const callsAnalist = await request.json();
    return callsAnalist;
  } catch (error) {
    console.log(error);
  }
};

export const fetchRecCall = async (id) => {
  try {
    const request = await fetch(`${REACT_APP_HOST}/api/download/file/${id}`);
    return request.url;
  } catch (error) {
    console.log(error);
  }
};

export const fetchCallOnDay = async (id) => {
  try {
    const request = await fetch(`${REACT_APP_HOST}/api/dbday/${id}`);
    const calls = await request.json();
    return calls;
  } catch (error) {
    console.log(error);
  }
};

export const fetchDataReport = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['idtenant'] = idtenant;
  
  try {
    const response = await axios
      .post(`${ipRequest}api/db/report`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const fetchSectors = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/db/report/sector`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const fetchDataReportList = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`${ipRequest}api/db/report/list`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const fetchRowsChartSectors = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['idtenant'] = idtenant;
  
  try {
    const response = await axios
      .post(`${ipRequest}api/db/report/list-sector-chart`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportReportGenerate = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['idtenant'] = idtenant;

  try {
    const response = await axios
      .post(`${ipRequest}api/report/export`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportReportGenerateLogs = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['idtenant'] = idtenant;
  dataRequest['tenantId'] = idtenant;

  try {
    const response = await axios
      .post(`${ipRequest}api/report/export-logs`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

const triggerFileDownload = (data, fileName) => {
  const blob = new Blob([data]);
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
};

export const exportReportDownloadStats = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const response = await axios
    .get(`${ipRequest}api/report/download-stats`, { headers: { Authorization: token }, responseType: 'blob' });
  triggerFileDownload(response.data, 'vigoscloud_report.xlsx');
  return response;
};

export const exportReportDownloadLogs = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const response = await axios
    .get(`${ipRequest}api/report/download-logs`, { headers: { Authorization: token }, responseType: 'blob' });
  triggerFileDownload(response.data, 'vigoscloud_logscalls.xlsx');
  return response;
};

export const exportCreateTrunks = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/trunks/create', dataRequest), {
    fallback: 'Não foi possível criar o tronco.'
  });

export const exportCreateTrunksBatch = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/trunks/create-batch', dataRequest), {
    fallback: 'Não foi possível criar a faixa de troncos.'
  });

export const exportPreviewTrunksBatch = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/trunks/create-batch/preview', dataRequest), {
    fallback: 'Não foi possível pré-visualizar a faixa de troncos.'
  });

export const createInboundDispatcherTrunk = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.post(
      `${ipRequest}api/config/trunks/create-inbound-dispatcher`,
      dataRequest,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const updateInboundDispatcherIps = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.post(
      `${ipRequest}api/config/trunks/update-inbound-dispatcher`,
      dataRequest,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const readInboundDispatcherIps = async (provider) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.get(
      `${ipRequest}api/config/trunks/inbound-dispatcher-ips/${encodeURIComponent(provider)}`,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const listInboundDispatchers = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.get(
      `${ipRequest}api/config/trunks/inbound-dispatchers`,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const exportSelectAllTrunks = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/trunks`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectAllTrunksWithInterconnection = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/trunks/with-interconnection`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectTrunkById = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/trunks/id`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectTrunkByRealNumber = async (realNumber) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    if (!realNumber || realNumber.trim() === '') {
      throw new Error('Número real é obrigatório');
    }

    const encodedRealNumber = encodeURIComponent(realNumber.trim());
    const response = await axios
      .get(`${ipRequest}api/config/trunks/real-number/${encodedRealNumber}`, { 
        headers: { Authorization: token } 
      });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar trunk por número real:', error);
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Erro ao buscar trunk',
      data: []
    };
  }
};

export const checkTrunkUsage = async (trunkName) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    if (!trunkName || trunkName.trim() === '') {
      throw new Error('Nome do trunk é obrigatório');
    }

    const encodedTrunkName = encodeURIComponent(trunkName.trim());
    const response = await axios
      .get(`${ipRequest}api/config/trunks/usage/${encodedTrunkName}`, { 
        headers: { Authorization: token } 
      });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao verificar uso do trunk:', error);
    return {
      success: false,
      hasConfigurations: false,
      incomingCount: 0,
      outboundCount: 0,
      totalCount: 0,
      message: error.response?.data?.message || error.message || 'Erro ao verificar uso do trunk'
    };
  }
};

export const exportUpdateTrunks = async (dataRequest) => {
  try {
    const response = await authorizedRequest('post', 'api/config/trunks/update', dataRequest);
    return apiSuccess(response);
  } catch (error) {
    const body = error.response && error.response.data;
    const usage = body && body.usage ? { usage: body.usage } : {};
    return apiFailure(error, 'Não foi possível atualizar o tronco.', usage);
  }
};

export const exportDeleteTrunks = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/trunks/delete', dataRequest), {
    fallback: 'Não foi possível excluir o tronco.'
  });

export const exportCreateEndpoints = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/endpoints/create', dataRequest), {
    fallback: 'Não foi possível criar os ramais.'
  });

export const exportSelectAllEndpointsResult = async () =>
  runRequest(() => authorizedRequest('get', 'api/config/endpoints'), {
    fallback: 'Não foi possível carregar os ramais.'
  });

export const exportSelectAllEndpoints = async () => {
  const result = await exportSelectAllEndpointsResult();
  return result.success ? result.data : undefined;
};

export const exportSelectEndpointsById = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/endpoints/id', dataRequest), {
    fallback: 'Não foi possível carregar os ramais selecionados.'
  });

export const exportUpdateEndpoints = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/endpoints/update', dataRequest), {
    fallback: 'Não foi possível atualizar os ramais.'
  });

export const exportDeleteEndpoints = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/endpoints/delete', dataRequest), {
    fallback: 'Não foi possível deletar os ramais selecionados.'
  });

export const getWebrtcCredentials = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios
      .get(`${ipRequest}api/config/endpoints/webrtc-credentials`, { headers: { Authorization: token } });
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { error: error.message };
    return { status, data };
  }
};

export const exportCreateQueues = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/queues/create', dataRequest), {
    fallback: 'Não foi possível criar a fila.'
  });

export const exportSelectAllQueues = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/queues`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectQueuesByName = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/queues/name`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportUpdateQueues = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/queues/update', dataRequest), {
    fallback: 'Não foi possível atualizar a fila.'
  });

export const exportDeleteQueues = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/queues/delete', dataRequest), {
    fallback: 'Não foi possível excluir a fila.'
  });

export const exportCreateQueueMembers = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/queues/members/create', dataRequest), {
    fallback: 'Não foi possível adicionar os membros à fila.'
  });

export const exportSelectAllQueueMembers = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/queues/members`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectQueueMemberByName = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/queues/members/name`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectQueueMemberByEndpoint = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/queues/members/endpoint`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportSelectQueueMemberById = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/config/queues/members/id`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const exportUpdateQueueMember = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/queues/members/update', dataRequest), {
    fallback: 'Não foi possível atualizar o membro da fila.'
  });

export const exportDeleteQueueMember = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/queues/members/delete', dataRequest), {
    fallback: 'Não foi possível remover o membro da fila.'
  });

export const exportReadQueueRoster = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/queues/members/roster', dataRequest), {
    fallback: 'Não foi possível carregar os membros da fila.'
  });

export const exportSyncQueueRoster = async (dataRequest) =>
  runRequest(() => authorizedRequest('put', 'api/config/queues/members/roster', dataRequest), {
    fallback: 'Falha ao salvar membros'
  });

export const getMusicOnHoldData = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  try {
    const response = await axios
      .get(`//${ipClean}/api/config/moh`, { headers: { Authorization: token }, params: dataRequest });
    return response;
  } catch (error) {
    return error;
  }
};

export const exportSelectAllMohs = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/moh`, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const exportSelectMohsByName = async (name) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/moh/name/${name}`, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const exportDeleteMohs = async (name) =>
  runRequest(() => authorizedRequest('delete', `api/config/moh/delete/${name}`), {
    fallback: 'Não foi possível excluir a música de espera.'
  });

export const readInterfaces = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/config/ip/interfaces`, { headers: { Authorization: token } });
    return [response.data];
  } catch (error) {
    return error;
  }
};

export const changeIpInterfaces = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios
      .post(`${ipRequest}api/config/ip/change`, dataRequest, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const stageIpChange = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.post(
      `${ipRequest}api/config/ip/stage`,
      dataRequest,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const confirmIpChange = async (token) => {
  const { token: authToken, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.post(
      `${ipRequest}api/config/ip/confirm`,
      { token },
      { headers: { Authorization: authToken } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const rollbackIpChange = async (token) => {
  const { token: authToken, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.post(
      `${ipRequest}api/config/ip/rollback`,
      { token },
      { headers: { Authorization: authToken } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const ipChangeHealth = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.get(
      `${ipRequest}api/config/ip/health`,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const getPjsipTransports = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.get(
      `${ipRequest}api/config/pjsip-transports`,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const updatePjsipTransports = async (payload) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios.post(
      `${ipRequest}api/config/pjsip-transports`,
      payload,
      { headers: { Authorization: token } }
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    const status = (error.response && error.response.status) || 500;
    const data = (error.response && error.response.data) || { message: error.message };
    return { status, data };
  }
};

export const readIpRoutes = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios
      .get(`${ipRequest}api/config/ip/routes`, { headers: { Authorization: token } });
    return [response.data];
  } catch (error) {
    return error;
  }
};

export const readManagedRoutes = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios
      .get(`${ipRequest}api/config/ip/routes/managed`, { headers: { Authorization: token } });
    return { ok: true, data: response.data };
  } catch (error) {
    const data = error.response && error.response.data ? error.response.data : null;
    return {
      ok: false,
      status: error.response ? error.response.status : 0,
      message: (data && data.message) || error.message || 'Falha ao listar rotas gerenciadas.',
      code: data && data.code,
    };
  }
};

export const readRoutesHealth = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios
      .get(`${ipRequest}api/config/ip/routes/health`, { headers: { Authorization: token } });
    return { ok: true, data: response.data };
  } catch (error) {
    const data = error.response && error.response.data ? error.response.data : null;
    return {
      ok: false,
      status: error.response ? error.response.status : 0,
      message: (data && data.message) || error.message || 'Falha ao consultar health de rotas.',
      code: data && data.code,
    };
  }
};

export const changeIpRoutes = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios
      .post(`${ipRequest}api/config/ip/routes`, dataRequest, { headers: { Authorization: token } });
    return {
      ok: true,
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    const data = error.response && error.response.data ? error.response.data : null;
    return {
      ok: false,
      status: error.response ? error.response.status : 0,
      message: (data && data.message) || error.message || 'Falha ao criar rota.',
      code: data && data.code,
      details: data && data.details,
      errors: data && data.errors,
    };
  }
};

export const deleteIpRoute = async (id) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  try {
    const response = await axios
      .delete(`${ipRequest}api/config/ip/routes/${ encodeURIComponent(id) }`, { headers: { Authorization: token } });
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    const data = error.response && error.response.data ? error.response.data : null;
    return {
      ok: false,
      status: error.response ? error.response.status : 0,
      message: (data && data.message) || error.message || 'Falha ao remover rota.',
      code: data && data.code,
    };
  }
};

export const sendRebootSystem = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/system/reboot`, { headers: { Authorization: token } });
    return [response.data];
  } catch (error) {
    return error;
  }
};

export const sendRegisterTrunkSystem = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/system/register`, dataRequest, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const applyDialplanSystem = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/system/dialplan`, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const loggerSipEnableSystem = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/system/logs`, dataRequest, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};


export const loggerSipDownloadSystem = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/system/logs/download/pcap`, { headers: { Authorization: token }, responseType: 'blob' });
    return response;
  } catch (error) {
    return error;
  }
};

export const internalDialplan = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/dialplan/internal', dataRequest), {
    fallback: 'Não foi possível salvar as chamadas internas.'
  });

export const entranceDialplan = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/dialplan/entrance', dataRequest), {
    fallback: 'Não foi possível salvar as chamadas de entrada.'
  });

export const externalDialplan = async (dataRequest) =>
  runRequest(() => authorizedRequest('post', 'api/config/dialplan/external', dataRequest), {
    fallback: 'Não foi possível salvar as chamadas de saída.'
  });

export const readContacts = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios
      .get(`//${ipClean}/contacts/read`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const createContact = async (dataRequest) =>
  runRequest(() => hostRequest('post', '/contacts/contactcreate', dataRequest), {
    fallback: 'Não foi possível criar o contato.'
  });

export const createPhone = async (dataRequest) =>
  runRequest(() => hostRequest('post', '/contacts/phonecreate', dataRequest), {
    fallback: 'Não foi possível adicionar o telefone.'
  });

export const getContatById = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios
      .post(`//${ipClean}/contacts/id`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getContatByAlias = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios
      .post(`//${ipClean}/contacts/alias`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getContatByDoc = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios
      .post(`//${ipClean}/contacts/doc`, dataRequest,{ headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const deleteContact = async (dataRequest) =>
  runRequest(() => hostRequest('post', '/contacts/contactdel', dataRequest), {
    fallback: 'Não foi possível excluir o contato.'
  });

export const sendPingAndTracertSystem = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const { query } = dataRequest;
    const response = await fetch(`//${ipClean}/api/system/command?${query}`, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const sendReloadAsteriskSystem = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const { command } = dataRequest;
    const response = await fetch(`//${ipClean}/api/system/command/asterisk?command=${command}`, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const deletePhone = async (dataRequest) =>
  runRequest(() => hostRequest('post', '/contacts/phonedel', dataRequest), {
    fallback: 'Não foi possível excluir o telefone.'
  });

export const updateContact = async (dataRequest) =>
  runRequest(() => hostRequest('post', '/contacts/update', dataRequest), {
    fallback: 'Não foi possível atualizar o contato.'
  });

export const updatePhone = async (dataRequest) =>
  runRequest(() => hostRequest('post', '/contacts/phone/update', dataRequest), {
    fallback: 'Não foi possível atualizar o telefone.'
  });

export const getDataDashboard = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['idtenant'] = idtenant;
  
  try {
    const response = await axios
      .post(`//${ipClean}/rpt/dashboard`, dataRequest, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const sendDataMohGenerate = async (dataRequest) =>
  runRequest(() => hostRequest('post', '/api/config/moh', dataRequest), {
    fallback: 'Não foi possível criar a música de espera.'
  });

export const sendDataMohUpdate = async (dataRequest) =>
  runRequest(() => hostRequest('put', '/api/config/moh/update', dataRequest), {
    fallback: 'Não foi possível atualizar a música de espera.'
  });


export const listAudiosByTenant = async (params = {}) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/dialplan/audios/list`);
    
    if (params.tenant) url.searchParams.append('tenant', params.tenant);
    if (params.type) url.searchParams.append('type', params.type);
    
    const response = await axios.get(url.toString(), { 
      headers: { Authorization: token } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao listar áudios:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao listar áudios'
    };
  }
};

export const checkAudioExists = async (params) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/dialplan/audios/check`);
    
    url.searchParams.append('tenant', params.tenant);
    url.searchParams.append('type', params.type);
    url.searchParams.append('file', params.file);
    
    const response = await axios.get(url.toString(), { 
      headers: { Authorization: token } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao verificar áudio:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao verificar áudio'
    };
  }
};


export const createInternalConfig = async (configData) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.post(
      `${ipRequest}api/config/dialplan/internals/configs`,
      configData,
      { headers: { Authorization: token } }
    );
    
    return response.data;
  } catch (error) {
    console.error('Erro ao criar configuração interna:', error);
    return {
      success: false,
      error: error.response?.data?.error || error.response?.data?.message || 'Erro ao criar configuração',
      details: error.response?.data?.details
    };
  }
};

export const getAllInternalConfigs = async (filters = {}) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/dialplan/internals/configs`);
    
    if (filters.tenant) url.searchParams.append('tenant', filters.tenant);
    if (filters.active_only !== undefined) url.searchParams.append('active_only', filters.active_only);
    
    const response = await axios.get(url.toString(), { 
      headers: { Authorization: token } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao listar configurações internas:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao listar configurações'
    };
  }
};

export const getInternalConfigById = async (configId) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.get(
      `${ipRequest}api/config/dialplan/internals/configs/${configId}`,
      { headers: { Authorization: token } }
    );
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar configuração interna:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao buscar configuração'
    };
  }
};

export const updateInternalConfig = async (configId, configData) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.put(
      `${ipRequest}api/config/dialplan/internals/configs/${configId}`,
      configData,
      { headers: { Authorization: token } }
    );
    
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar configuração interna:', error);
    return {
      success: false,
      error: error.response?.data?.error || error.response?.data?.message || 'Erro ao atualizar configuração',
      details: error.response?.data?.details
    };
  }
};

export const deleteInternalConfig = async (configId) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.delete(
      `${ipRequest}api/config/dialplan/internals/configs/${configId}`,
      { headers: { Authorization: token } }
    );
    
    return response.data;
  } catch (error) {
    console.error('Erro ao remover configuração interna:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao remover configuração'
    };
  }
};

export const getInternalStatistics = async (tenant = null) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/dialplan/internals/statistics`);
    if (tenant) url.searchParams.append('tenant', tenant);
    
    const response = await axios.get(url.toString(), { 
      headers: { Authorization: token } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar estatísticas:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao buscar estatísticas'
    };
  }
};

export const getInternalDataByTenant = async (tenant) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/dialplan/internals/tenant`);
    if (tenant) url.searchParams.append('tenant', tenant);
    
    const response = await axios.get(url.toString(), { 
      headers: { Authorization: token } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar dados do tenant:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao buscar dados do tenant'
    };
  }
};

export const getContextsByTenant = async (tenant) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/dialplan/contexts`);
    if (tenant) url.searchParams.append('tenant', tenant);
    
    const response = await axios.get(url.toString(), { 
      headers: { Authorization: token } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar contextos:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao buscar contextos'
    };
  }
};

export const getContextsFilteredByTenant = async (tenant) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/dialplan/contexts-filtered`);
    if (tenant) url.searchParams.append('tenant', tenant);
    
    const response = await axios.get(url.toString(), { 
      headers: { Authorization: token } 
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar contextos filtrados:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao buscar contextos filtrados'
    };
  }
};

export const createIntegration = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .post(`${ipRequest}api/integrations`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getAllIntegrations = async () => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/integrations`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getIntegrationById = async (id) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/integrations/${id}`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getIntegrationsByAccountcode = async (accountcode) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/integrations/accountcode/${accountcode}`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getIntegrationsByType = async (type) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .get(`${ipRequest}api/integrations/type/${type}`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateIntegration = async (id, dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .put(`${ipRequest}api/integrations/${id}`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const deleteIntegration = async (id) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios
      .delete(`${ipRequest}api/integrations/${id}`, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};


export const createOutboundConfig = async (configData) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.post(
      `${ipRequest}api/config/outbound/configs`,
      configData,
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    console.error('Erro ao criar configuração outbound:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao criar configuração',
      message: error.response?.data?.message || error.message
    };
  }
};

export const getAllOutboundConfigs = async (filters = {}) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/outbound/configs`);
    
    if (filters.tenant) url.searchParams.append('tenant', filters.tenant);
    if (filters.callType) url.searchParams.append('callType', filters.callType);
    if (filters.activeOnly !== undefined) url.searchParams.append('activeOnly', filters.activeOnly);
    
    const response = await axios.get(url.toString(), {
      headers: { Authorization: token }
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao listar configurações outbound:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao listar configurações',
      data: []
    };
  }
};

export const getOutboundConfigById = async (id) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.get(
      `${ipRequest}api/config/outbound/configs/${id}`,
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar configuração outbound:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao buscar configuração',
      data: null
    };
  }
};

export const updateOutboundConfig = async (id, configData) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.put(
      `${ipRequest}api/config/outbound/configs/${id}`,
      configData,
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar configuração outbound:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao atualizar configuração',
      message: error.response?.data?.message || error.message
    };
  }
};

export const deleteOutboundConfig = async (id) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const response = await axios.delete(
      `${ipRequest}api/config/outbound/configs/${id}`,
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    console.error('Erro ao remover configuração outbound:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao remover configuração',
      message: error.response?.data?.message || error.message
    };
  }
};

export const getOutboundStatistics = async (tenant = null) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    const url = new URL(`${ipRequest}api/config/outbound/statistics`);
    if (tenant) url.searchParams.append('tenant', tenant);
    
    const response = await axios.get(url.toString(), {
      headers: { Authorization: token }
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar estatísticas outbound:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao buscar estatísticas',
      data: []
    };
  }
};

export const getAvailableTrunks = async (tenant = null) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const url = new URL(`${ipRequest}api/config/outbound/trunks`);
    if (tenant) url.searchParams.append('tenant', tenant);

    const response = await axios.get(url.toString(), {
      headers: { Authorization: token }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao buscar troncos disponíveis:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao buscar troncos',
      data: []
    };
  }
};

const outboundGroupsError = (error, fallback, extra = {}) => ({
  success: false,
  error: error.response?.data?.error || fallback,
  code: error.response?.data?.code,
  status: error.response?.status,
  ...extra
});

export const getOutboundGroups = async (tenant = null, activeOnly = false) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const url = new URL(`${ipRequest}api/config/outbound/groups`);
    if (tenant) url.searchParams.append('tenant', tenant);
    if (activeOnly) url.searchParams.append('activeOnly', 'true');

    const response = await axios.get(url.toString(), { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    console.error('Erro ao listar grupos de saída:', error);
    return outboundGroupsError(error, 'Erro ao listar grupos de saída', { data: [] });
  }
};

export const getOutboundGroupById = async (id) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios.get(`${ipRequest}api/config/outbound/groups/${id}`, {
      headers: { Authorization: token }
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar grupo de saída:', error);
    return outboundGroupsError(error, 'Erro ao buscar grupo de saída', { data: null });
  }
};

export const getOutboundGroupTrunks = async (tenant = null) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const url = new URL(`${ipRequest}api/config/outbound/groups/trunks`);
    if (tenant) url.searchParams.append('tenant', tenant);

    const response = await axios.get(url.toString(), { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar troncos do cliente:', error);
    return outboundGroupsError(error, 'Erro ao buscar troncos do cliente', { data: [] });
  }
};

export const createOutboundGroup = async (groupData) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios.post(`${ipRequest}api/config/outbound/groups`, groupData, {
      headers: { Authorization: token }
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao criar grupo de saída:', error);
    return outboundGroupsError(error, 'Erro ao criar grupo de saída', {
      details: error.response?.data?.details
    });
  }
};

export const updateOutboundGroup = async (id, groupData) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios.put(`${ipRequest}api/config/outbound/groups/${id}`, groupData, {
      headers: { Authorization: token }
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar grupo de saída:', error);
    return outboundGroupsError(error, 'Erro ao atualizar grupo de saída', {
      endpoints: error.response?.data?.endpoints
    });
  }
};

export const deleteOutboundGroup = async (id) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios.delete(`${ipRequest}api/config/outbound/groups/${id}`, {
      headers: { Authorization: token }
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao remover grupo de saída:', error);
    return outboundGroupsError(error, 'Erro ao remover grupo de saída', {
      endpoints: error.response?.data?.endpoints
    });
  }
};

export const applyOutboundGroupRange = async (id, range) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios.post(`${ipRequest}api/config/outbound/groups/${id}/apply-range`, range, {
      headers: { Authorization: token }
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao aplicar faixa ao grupo de saída:', error);
    return outboundGroupsError(error, 'Erro ao aplicar faixa de ramais');
  }
};

export const removeOutboundGroupRange = async (id, range = {}) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();

  try {
    const response = await axios.post(`${ipRequest}api/config/outbound/groups/${id}/remove-range`, range, {
      headers: { Authorization: token }
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao remover faixa do grupo de saída:', error);
    return outboundGroupsError(error, 'Erro ao remover faixa de ramais');
  }
};

const CARRIERS_PATH = 'api/config/carriers';

const carrierPath = (carrierId) => `${CARRIERS_PATH}/${encodeURIComponent(carrierId)}`;

const tenantQuery = (tenant) => `?tenant=${encodeURIComponent(tenant || '')}`;

const selectCarrierBody = (response) => (response && response.data ? response.data.data : null);

export const getCarriers = async (tenant) =>
  runRequest(() => authorizedRequest('get', `${CARRIERS_PATH}${tenantQuery(tenant)}`), {
    fallback: 'Erro ao carregar operadoras.',
    select: (response) => {
      const carriers = selectCarrierBody(response);
      return Array.isArray(carriers) ? carriers : [];
    },
  });

export const getCarrierById = async (carrierId, tenant) =>
  runRequest(() => authorizedRequest('get', `${carrierPath(carrierId)}${tenantQuery(tenant)}`), {
    fallback: 'Erro ao carregar operadora.',
    select: selectCarrierBody,
  });

export const createCarrier = async (payload) =>
  runRequest(() => authorizedRequest('post', CARRIERS_PATH, payload), {
    fallback: 'Erro ao salvar operadora.',
    select: selectCarrierBody,
  });

export const updateCarrier = async (carrierId, payload) =>
  runRequest(() => authorizedRequest('put', carrierPath(carrierId), payload), {
    fallback: 'Erro ao salvar operadora.',
    select: selectCarrierBody,
  });

export const deleteCarrier = async (carrierId, tenant) =>
  runRequest(() => authorizedRequest('delete', `${carrierPath(carrierId)}${tenantQuery(tenant)}`), {
    fallback: 'Erro ao excluir operadora.',
    select: selectCarrierBody,
  });

const PORT_REDIRECTS_PATH = 'api/config/ip/port-redirects';

const selectPortRedirectRules = (response) => {
  const rules = response && response.data ? response.data.rules : null;
  return Array.isArray(rules) ? rules : [];
};

export const getPortRedirects = async () =>
  runRequest(() => authorizedRequest('get', PORT_REDIRECTS_PATH), {
    fallback: 'Erro ao carregar as regras de redirect.',
    select: selectPortRedirectRules,
  });

export const createPortRedirect = async (payload) =>
  runRequest(() => authorizedRequest('post', PORT_REDIRECTS_PATH, payload), {
    fallback: 'Erro ao salvar a regra de redirect.',
  });

export const deletePortRedirect = async (id) =>
  runRequest(() => authorizedRequest('delete', `${PORT_REDIRECTS_PATH}/${encodeURIComponent(id)}`), {
    fallback: 'Erro ao excluir a regra de redirect.',
  });

const RECORDINGS_BACKUP_PATH = 'api/system/recordings-backup';

export const getRecordingsBackupStatus = async () =>
  runRequest(() => authorizedRequest('get', `${RECORDINGS_BACKUP_PATH}/status`), {
    fallback: 'Erro ao carregar o backup de gravações.',
  });

export const testRecordingsBackupConnection = async (payload) =>
  runRequest(() => authorizedRequest('post', `${RECORDINGS_BACKUP_PATH}/test-connection`, payload), {
    fallback: 'Erro ao testar a conexão com o backup.',
  });

export const registerRecordingsBackup = async (payload) =>
  runRequest(() => authorizedRequest('post', `${RECORDINGS_BACKUP_PATH}/register`, payload), {
    fallback: 'Erro ao registrar o backup de gravações.',
  });

export const rebindRecordingsBackup = async (payload) =>
  runRequest(() => authorizedRequest('post', `${RECORDINGS_BACKUP_PATH}/rebind`, payload), {
    fallback: 'Erro ao re-vincular o backup de gravações.',
  });

export const rotateRecordingsBackupKey = async () =>
  runRequest(() => authorizedRequest('post', `${RECORDINGS_BACKUP_PATH}/rotate-key`), {
    fallback: 'Erro ao trocar a chave do backup.',
  });

export const runRecordingsBackupNow = async () =>
  runRequest(() => authorizedRequest('post', `${RECORDINGS_BACKUP_PATH}/run-now`), {
    fallback: 'Erro ao iniciar o envio das gravações.',
  });

export const updateRecordingsBackupSettings = async (payload) =>
  runRequest(() => authorizedRequest('put', `${RECORDINGS_BACKUP_PATH}/settings`, payload), {
    fallback: 'Erro ao salvar a configuração do backup.',
  });
